<template>
  <div class="dashboard-container">
    <!-- Cabeçalho com botão de cadastro -->
    <v-card-title class="dashboard-header">
      <v-spacer />
      <v-btn
        color="primary"
        outlined
        @click="$router.push('listaMedicosUnidade')"
      >
        <v-icon left>mdi-account-plus</v-icon>
        Cadastros
      </v-btn>
    </v-card-title>

    <!-- Cards de métricas -->
    <v-row class="metrics-row">
      <v-col
        v-for="(item, i) in stats"
        :key="'metric-'+i"
        xl="3" lg="3" md="4" sm="6" xs="12"
      >
        <v-card class="metric-card" elevation="2">
          <!-- Estado de carregamento -->
          <template v-if="load">
            <v-row>
              <v-col cols="9">
                <v-skeleton-loader type="card-heading" />
                <v-skeleton-loader class="ml-4" type="text" />
              </v-col>
              <v-col cols="3">
                <v-skeleton-loader type="avatar" />
              </v-col>
            </v-row>
          </template>

          <!-- Conteúdo carregado -->
          <template v-else>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div class="metric-content">
                <div class="metric-title">{{ item.title }}</div>
                <div class="metric-value">{{ item.value }}</div>
                <div class="metric-trend">
                  <span :style="{ color: item.colorPercentage }">
                    {{ item.percentage }}%
                  </span>
                  <span class="metric-detail">
                    {{ item.detail }} <strong>{{ item.lastMonth }}</strong>
                  </span>
                </div>
              </div>
              <v-avatar
                class="metric-icon"
                size="47"
                :color="item.iconBackground"
              >
                <v-icon dark color="white">{{ item.icon }}</v-icon>
              </v-avatar>
            </div>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <!-- Seção de rankings -->
    <v-row class="rankings-row">
      <v-col cols="12" md="8">
        <!-- Carrossel de rankings -->
        <v-card class="ranking-carousel" elevation="2">
          <v-carousel v-model="carouselModel" height="100%" show-arrows-on-hover>
            <!-- Slide 1: Tempo médio de atendimento -->
            <v-carousel-item>
              <v-card flat>
                <v-card-title>Top 5 Médicos [Média tempo de Atendimentos]</v-card-title>
                <v-card-text>
                  <v-list flat>
                    <v-list-item-group color="primary">
                      <v-list-item
                        v-for="(item, i) in top5MediaAtendimentos"
                        :key="'time-'+i"
                      >
                        <v-list-item-icon>
                          <v-avatar size="35" color="primary">
                            <span class="white--text">{{ i + 1 }}</span>
                          </v-avatar>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.nome }}</v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.media ? item.media.toFixed(2) : '0.00' }} minutos
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-carousel-item>

            <!-- Slide 2: Solicitações de exames -->
            <v-carousel-item>
              <v-card flat>
                <v-card-title>Top 5 Médicos [Solicitações de Exames]</v-card-title>
                <v-card-text>
                  <v-list flat>
                    <v-list-item-group color="primary">
                      <v-list-item
                        v-for="(item, i) in top5Solicitacoes"
                        :key="'exam-'+i"
                      >
                        <v-list-item-icon>
                          <v-avatar size="35" color="primary">
                            <span class="white--text">{{ i + 1 }}</span>
                          </v-avatar>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.nome }}</v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.numeroSolicitacoes }} solicitações
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-col>

      <!-- Card de exames -->
      <v-col cols="12" md="4">
        <v-card class="exams-card" elevation="2">
          <v-card-title>Top 5 Exames</v-card-title>
          <v-card-text>
            <v-list flat>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, i) in exames"
                  :key="'exam-item-'+i"
                >
                  <v-list-item-icon>
                    <v-avatar size="35" color="primary">
                      <span class="white--text">{{ i + 1 }}</span>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.value }} solicitações
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import medicoService from '../../../services/medico.service'

export default {
  data () {
    return {
      user: {},
      load: true,
      load2: true,
      carouselModel: 0,
      stats: [
        {
          title: 'Tempo por atendimento',
          value: '--',
          percentage: '--',
          colorPercentage: '',
          lastMonth: '--',
          detail: 'carregando...',
          icon: 'mdi-account-clock',
          iconBackground: 'purple'
        },
        {
          title: 'Médicos cadastrados',
          value: '--',
          percentage: '',
          colorPercentage: '',
          lastMonth: '',
          detail: '',
          icon: 'mdi-doctor',
          iconBackground: 'accent'
        },
        {
          title: 'Total de atendimentos',
          value: '--',
          percentage: '--',
          colorPercentage: '',
          lastMonth: '--',
          detail: 'carregando...',
          icon: 'mdi-medication',
          iconBackground: 'green'
        },
        {
          title: 'Exames Solicitados',
          value: '--',
          percentage: '--',
          colorPercentage: '',
          lastMonth: '--',
          detail: 'carregando...',
          icon: 'mdi-medical-bag',
          iconBackground: 'yellow'
        },
        {
          title: 'Medicamentos Solicitados',
          value: '--',
          percentage: '--',
          colorPercentage: '',
          lastMonth: '--',
          detail: 'carregando...',
          icon: 'mdi-pill',
          iconBackground: 'blue'
        }
      ],
      top5MediaAtendimentos: [
        { nome: 'Carregando...', media: 0 }
      ],
      top5Solicitacoes: [
        { nome: 'Carregando...', numeroSolicitacoes: 0 }
      ],
      exames: [
        { title: 'Carregando...', value: '--' },
        { title: 'Carregando...', value: '--' },
        { title: 'Carregando...', value: '--' },
        { title: 'Carregando...', value: '--' },
        { title: 'Carregando...', value: '--' }
      ]
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.retornarMetricasMedico()
    this.retornarTop5()
  },
  methods: {
    async retornarMetricasMedico () {
      this.load = true
      try {
        const response = await medicoService.medico.retornarMetricasMedico(this.user.idUnidade)
        if (response.status === 200) {
          this.processMetrics(response.data)
        }
      } catch (error) {
        console.error('Erro ao carregar métricas:', error)
      } finally {
        this.load = false
      }
    },

    processMetrics (data) {
      // Tempo médio de atendimento
      this.updateStat(0,
        data.tempoMedioConsultas[1].tempoMedioAtendimento.toFixed(1),
        data.tempoMedioConsultas[0].tempoMedioAtendimento.toFixed(1),
        'média'
      )

      // Médicos cadastrados
      this.stats[1].value = data.quantidadeMedicosCadastrados

      // Total de atendimentos
      this.updateStat(2,
        data.tempoMedioConsultas[1].numeroDeAtendimentos,
        data.tempoMedioConsultas[0].numeroDeAtendimentos
      )

      // Exames solicitados
      this.updateStat(3,
        data.numeroExamesSolicitados[1].totalExames,
        data.numeroExamesSolicitados[0].totalExames
      )

      // Medicamentos solicitados
      this.updateStat(4,
        data.numeroMedicamentosReceitados[1].totalMedicamentos,
        data.numeroMedicamentosReceitados[0].totalMedicamentos
      )
    },

    updateStat (index, currentValue, lastMonthValue, suffix = '') {
      this.stats[index].value = currentValue + (suffix ? ' ' + suffix : '')
      this.stats[index].lastMonth = lastMonthValue + (suffix ? ' ' + suffix : '')

      const difference = parseFloat(currentValue) - parseFloat(lastMonthValue)
      const percentage = ((difference / parseFloat(lastMonthValue)) * 100).toFixed(1)

      this.stats[index].percentage = Math.abs(percentage)
      this.stats[index].detail = difference > 0 ? 'maior que o último mês' : 'menor que o último mês'
      this.stats[index].colorPercentage = difference > 0 ? '#4CAF50' : '#F44336'
    },

    async retornarTop5 () {
      this.load2 = true
      try {
        const response = await medicoService.medico.retornarTop5(this.user.idUnidade)
        if (response.status === 200) {
          this.top5MediaAtendimentos = response.data.topFiveMediasMedicos
          this.top5Solicitacoes = response.data.topFiveSolicitacoesMedicos

          // Atualiza lista de exames se existir nos dados
          if (response.data.topExames) {
            this.exames = response.data.topExames.map((exame, index) => ({
              title: exame.nome || `Exame ${index + 1}`,
              value: exame.quantidade || '0'
            }))
          }
        }
      } catch (error) {
        console.error('Erro ao carregar rankings:', error)
      } finally {
        this.load2 = false
      }
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 16px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.dashboard-header {
  padding: 16px;
}

.metrics-row {
  margin: 16px 0;
}

.metric-card {
  border-radius: 16px;
  margin: 8px;
  height: 120px;
  transition: transform 0.3s ease;
}

.metric-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
}

.metric-content {
  padding: 16px;
}

.metric-title {
  color: #616161;
  font-size: 16px;
  font-weight: normal;
}

.metric-value {
  font-weight: bold;
  font-size: 22px;
  color: #344767;
  margin: 4px 0;
}

.metric-trend {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 4px;
}

.metric-trend span:first-child {
  font-weight: 500;
  margin-right: 4px;
}

.metric-detail {
  color: #757575;
}

.metric-icon {
  margin: 16px;
}

.rankings-row {
  margin-top: 24px;
}

.ranking-carousel, .exams-card {
  border-radius: 16px;
  height: 100%;
}

.exams-card {
  height: 100%;
}

@media (max-width: 960px) {
  .dashboard-container {
    padding: 8px;
  }

  .metric-card {
    height: 110px;
  }
}

@media (max-width: 600px) {
  .metric-content {
    padding: 12px;
  }

  .metric-title {
    font-size: 14px;
  }

  .metric-value {
    font-size: 20px;
  }
}
</style>
